import { useQuery } from "@tanstack/react-query"
import { Axios } from "../utils/Axios"


export const useStaffs = (page, limit, name) => {
    return useQuery({
        queryKey: ['staffs'],
        queryFn: async () => {
            const res = await Axios.get('/staff', { params: { page, limit, name } });
            return res.data;
        }
    })
}